import type { Ref } from 'vue'

import { normalizeMoney } from '@/lib/adapters/common.adapter'
import { useApi } from '@/lib/helpers/api.helpers'
import { financeClient } from '@/lib/services/finance.service'
import type { PaymentSummary } from '@/lib/types/payments.types'

export const useGetPaymentSummary = (userIdRef: Ref<number>) => {
  return useApi<PaymentSummary>(async () => {
    const summary = await financeClient.paymentSummaryControllerGetPaymentSummary(userIdRef.value)
    return {
      ...summary,
      currentBalance: normalizeMoney(summary.currentBalance),
      upcomingPayment: {
        ...summary.upcomingPayout,
        amount: normalizeMoney(summary.upcomingPayout.amount),
        paymentDate: summary.upcomingPayout.paymentDate,
        isPayable: summary.upcomingPayout.isPayable,
        payoutErrors: summary.payoutErrors,
      },
    }
  })
}
